import { render, staticRenderFns } from "./browser-support-guide.vue?vue&type=template&id=1186bae5&"
import script from "./browser-support-guide.vue?vue&type=script&lang=js&"
export * from "./browser-support-guide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports